import { FilterDefinition, Operators } from "@monolith-forensics/monolith-ui";
import { MitreAPI } from "./mitre.api";
import { GetTacticsResult, GetTechniquesResult } from "./mitre.types";

export const TacticsFilterDefinition: FilterDefinition = {
  label: "Mitre Tactic",
  pluralLabel: "Mitre Tactics",
  dataField: "mitre_tactic_uuid",
  inputType: "multiselect",
  operators: [Operators.In, Operators.NIn],
  query: {
    initialPageParam: 1,
    cacheKey: JSON.stringify(MitreAPI.tacticsQueryKey),
    loadPage: async () => {
      const page = (await MitreAPI.getTactics()) as GetTacticsResult;

      return {
        items: page.data.map((tactic) => ({
          label: tactic.name,
          value: tactic.uuid.toString(),
          data: tactic,
        })),
        nextPageParam: null,
      };
    },
  },
};

export const TechniquesFilterDefinition: FilterDefinition = {
  label: "Mitre Technique",
  pluralLabel: "Mitre Techniques",
  dataField: "mitre_technique_uuid",
  inputType: "multiselect",
  operators: [Operators.In, Operators.NIn],
  dropDownOptions: {
    style: { width: 400 },
  },
  query: {
    initialPageParam: 1,
    cacheKey: ({ search }) =>
      JSON.stringify([...MitreAPI.techniquesQueryKey, { pageSize: 1000 }]),
    loadPage: async ({ pageParam, search }) => {
      const page = (await MitreAPI.getTechniques({
        page: pageParam as number,
        pageSize: 1000,
      })) as GetTechniquesResult;

      return {
        items: page.data.map((technique) => ({
          label: technique.name,
          value: technique.uuid,
          data: technique,
        })),
        nextPageParam: page.nextPage,
      };
    },
  },
};
